import React from "react";
import Header from "../../common/components/Header";
import {MAIN_CONTENT} from "../../styles";

export const RegistrationReceived = (props) => (
    <div style={MAIN_CONTENT}>
        <Header>Registration received</Header>
        <div style={{padding: 10}}>
            <h3>Thank you for registering</h3>
            <h4>You will receive an email shortly allowing you to set your password.</h4>
        </div>
    </div>
);

export default RegistrationReceived;




/** WEBPACK FOOTER **
 ** ./src/main/javascript/authentication/components/RegistrationReceived.js
 **/